export default __webpack_public_path__ + "static/media/Picture1.476915c5.png";